import React, { useContext } from "react";
import PropTypes from "prop-types";
import i18n from "~/assets/js/Helpers/i18n";
import Button from "~/assets/js/components/Button";
import Headline from "~/assets/js/components/Typography/Headline";
import { PlusCircle } from "react-feather";
import { ProductsDetailsContext } from "~/assets/js/pages/ProductDetails/ProductsProvider";
import Dressing from "./Dressing";
import NoDressings from "./NoDressings";
import DressingPopup from "./DressingPopup";
import { calculateDressingDisplayPrice } from "~/assets/js/Format";

const Dressings = ({ open, setOpen }) => {
    const { state, isDiscoverMode, triggerAddressPopup, isSauceProduct } =
        useContext(ProductsDetailsContext);
    const noDressings = state.dressings.length < 1;

    return (
        <>
            <div id="dressings" className="dressings">
                <div className="dressings__header">
                    <Headline size={6}>
                        {isSauceProduct
                            ? i18n.t("sauces.title")
                            : i18n.t("dressings.title")}
                    </Headline>
                    <Button
                        customStyle="dressings-CTA"
                        label={
                            isSauceProduct
                                ? i18n.t("sauces.choose")
                                : i18n.t("dressings.choose")
                        }
                        size="XS"
                        variant="secondary"
                        icon={<PlusCircle />}
                        onClick={() =>
                            isDiscoverMode
                                ? triggerAddressPopup()
                                : setOpen(true)
                        }
                    />
                </div>
                {noDressings ? (
                    <NoDressings
                        label={
                            isSauceProduct
                                ? i18n.t("sauces.noSauce")
                                : i18n.t("dressings.noDressing")
                        }
                    />
                ) : (
                    <>
                        {state.dressings.map((dressing) => {
                            const price = calculateDressingDisplayPrice(
                                dressing,
                                state.dressings
                            );
                            return (
                                <Dressing
                                    firstDressingFree={price === "free"}
                                    key={`dressing-${dressing.product_id}`}
                                    dressing={dressing}
                                />
                            );
                        })}
                    </>
                )}
            </div>
            <DressingPopup open={open} handleClose={() => setOpen(false)} />
        </>
    );
};

Dressings.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
};

export default Dressings;
